import { useCallback, useState } from "react";
import { mutate } from "swr";
import { salesService } from "../../api_client";

export function useUpdateSaleShippingAddress() {
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const update = useCallback(async (saleId: number, shippingAddressId: number) => {
    setLoading(true);
    setError(null);
    try {
      await salesService.updateSaleShippingAddress(saleId, { shippingAddressId });
      // useSaleDetails / useDetailApi key the cache by `<key>-<id>`. Re-fetch
      // every cached sale-details entry so PaymentView's read sees the new
      // `shippingPartner` immediately. Revalidate only — passing `undefined`
      // as data blanks the cached sale, which unmounts the payment form and
      // wipes the card the buyer already typed.
      await mutate((key) => typeof key === "string" && key.startsWith("sale-details"));
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { update, isLoading, error };
}
